import script from "./taskCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./taskCard.vue?vue&type=script&setup=true&lang=ts"

import "./taskCard.vue?vue&type=style&index=0&id=b6a5ba1c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6a5ba1c"]])

export default __exports__